import React, { useEffect, useState } from 'react';
import {
  ContentContainer,
  DrawerTitleContainer,
  MainContainer,
  SummaryButton,
  SummaryText,
  ChevronIcon,
  SidebarContainer,
} from '@atoms/tableData/styles/contentContainer.styles';
import SubHeaderPLPast from '@atoms/subHeaderText/subHeaderPLPast'; //for past page
import PursuitLeaderPastTable from '@templates/pursuitLeader/forecast/tableComponent/pursuitLeaderPastTable'; //for past forecast
import PlPastSideBar from '@templates/pursuitLeader/forecast/sideBarComponent/plPastSideBar.component'; //for past side basr
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import DownChevron from '@assets/icons/down-chevron.png';
import AlertBanner from '@atoms/alerts/alertBanner';
import { Current_Page_Name, Recoil_Summary_Drawer_Toggle } from '@recoil/recoil';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { PAGES_NAME } from '../../../constants/commonConstants';

const PursuitLeadePastForecast = props => {
  const propsData = props.data;
  const [isOpen, setIsOpen] = useState(false);
  const summaryDrawerToggle = useRecoilValue(Recoil_Summary_Drawer_Toggle);
  const setCurrentPageName = useSetRecoilState(Current_Page_Name);

  useEffect(async () => {
    if (isOpen) toggleDrawer();
  }, [summaryDrawerToggle]);

  const toggleDrawer = () => {
    setIsOpen(isOpen => !isOpen);
  };

  useEffect(() => {
    setCurrentPageName(PAGES_NAME.PAST_FORECAST);
  }, []);

  const forecast_type = props.data.forecast_type;
  const year = props.data.year;
  const quarter = props.data.quarter;
  const email = props.data.email;
  let month = props.data.month;

  month = month.charAt(0).toUpperCase() + month.slice(1);

  return (
    <MainContainer>
      <ContentContainer>
        <AlertBanner
          title="NOTE"
          description="This is a view-only snapshot of the forecast you submitted."
          type="past"
        />
        <SubHeaderPLPast
          year={year}
          forecast_type={forecast_type}
          month={month}
          quarter={quarter}
        />
        <PursuitLeaderPastTable
          email={email}
          year={year}
          month={month}
          quarter={quarter}
          forecast_type={forecast_type}
        />
      </ContentContainer>

      <SidebarContainer>
        <PlPastSideBar data={propsData} />
      </SidebarContainer>

      <SummaryButton onClick={toggleDrawer}>
        <DrawerTitleContainer>
          <ChevronIcon
            src={DownChevron}
            alt="Expand Icon"
            className={!isOpen ? 'expanded' : 'collapsed'}
          />
          <SummaryText>Summary</SummaryText>
        </DrawerTitleContainer>
      </SummaryButton>

      <Drawer
        className="forecast-drawer"
        duration={250}
        onClose={toggleDrawer}
        direction="bottom"
        open={isOpen}
        overlayOpacity="0.6"
        zIndex={100}
      >
        <PlPastSideBar data={propsData} />
      </Drawer>
    </MainContainer>
  );
};

export default PursuitLeadePastForecast;
